/* El cupón correcto SIEMPRE, según lo que haya en la cesta (Mau, 2026-08-24).

   ── El fallo que arregla ──────────────────────────────────────────────
   Las dos tarjetas (Starter y Protocolo) añaden EL MISMO dispositivo y se
   diferencian por su gel automático y por su cupón. El ATC planta la
   cookie del código con /discount/…, pero Shopify se queda con el PRIMER
   código aplicado al carrito: quien añadía Starter, lo quitaba y pasaba al
   Protocolo llegaba al checkout con "SKINDION STARTER −50,01" y pagaba
   99,99 € por el Protocolo (reproducido en el preview, 2026-08-24).

   ── La solución ───────────────────────────────────────────────────────
   No depender de la cookie: al pulsar "pagar", se lee /cart.js, se decide
   el código por el GEL que lleve la cesta y se navega a
   /checkout?discount=CÓDIGO, que pisa el código pegado al carrito
   (verificado: con carrito sucio de Starter, el checkout pasó a
   "PROTOCOLO FIRMEZA −25,00" y 125,00 €).

   ── Convivencia con el order bump ─────────────────────────────────────
   js-priority-plus.js intercepta el mismo botón en fase de captura y, si
   abre su popup, llama a stopImmediatePropagation(): este archivo se carga
   DESPUÉS, así que en ese caso ni se entera (el popup manda). Cuando
   Priority+ deja pasar el click (o re-clicka al aceptar/rechazar), este
   interceptor toma el relevo y navega con el cupón correcto.

   ── Principio rector: NUNCA bloquear una venta ────────────────────────
   Si /cart.js falla, si la cesta no lleva ninguno de nuestros geles o si
   preventDefault no se puede aplicar, el flujo acaba SIEMPRE en el botón
   de Rebuy con su comportamiento de siempre. */
(function () {
  'use strict';

  var CHECKOUT_BTN = '.rebuy-cart__checkout-button';

  /* El gel manda: es lo único que distingue el carrito de un plan del otro
     (el dispositivo es el mismo producto en los dos). */
  var PLANES = [
    { variant: 49514997154048, handle: 'gel-conductor-hidratante-auto', code: 'Protocolo Firmeza' },
    { variant: 49542155305216, handle: 'gel-conductor-hidratante-reposicion', code: 'Skindion Starter' }
  ];

  var pasando = false; /* guard del re-click sintético */
  var bound = false;

  /**
   * Código que le toca a esta cesta, o '' si no le toca ninguno.
   * @param {{items: Array<{variant_id:number, handle?:string}>}} cart
   * @returns {string}
   */
  function codigoDe(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      for (var p = 0; p < PLANES.length; p++) {
        if (items[i].variant_id === PLANES[p].variant || items[i].handle === PLANES[p].handle) {
          return PLANES[p].code;
        }
      }
    }
    return '';
  }

  /** Dejar pasar: re-click al botón de Rebuy para que corra su propio handler. */
  function seguir() {
    pasando = true;
    var btn = document.querySelector(CHECKOUT_BTN);
    if (btn) btn.click();
    pasando = false;
  }

  /**
   * Al checkout con el código correcto.
   *
   * Van las DOS vías a propósito y en este orden:
   *   1. /discount/CÓDIGO reescribe la cookie discount_code.
   *   2. /checkout?discount=CÓDIGO lo pasa también por URL.
   * Con solo la URL no basta: si la cookie trae otro código (la clienta probó
   * el otro plan antes), el checkout hace caso a la COOKIE y cobra el cupón
   * viejo. Cazado en el preview el 2026-08-24 con el flujo del upgrade.
   */
  function irAlCheckout(code) {
    /* Con code VACÍO ('') el ?discount= sin valor DESACTIVA el código que
       quedara amarrado al checkout de la sesión. Verificado en el live
       (14g): con "Skindion Starter" amarrado, el checkout cobraba 99,99 a
       la compra única; con ?discount= vacío volvió a 150,00 sin error. */
    var url = '/checkout?discount=' + encodeURIComponent(code);
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url += '&preview_theme_id=' + encodeURIComponent(preview);

    var plantada = code
      ? window.fetch('/discount/' + encodeURIComponent(code)).catch(function () { /* la URL aún puede salvarlo */ })
      : Promise.resolve();
    plantada.then(function () { window.location.assign(url); });
  }

  function onClickCapture(e) {
    var btn = e.target && e.target.closest ? e.target.closest(CHECKOUT_BTN) : null;
    if (!btn) return;
    if (pasando) return;

    try {
      e.preventDefault();
      e.stopImmediatePropagation();
    } catch (err) {
      return; /* si no se puede bloquear, que siga el flujo normal de Rebuy */
    }

    window
      .fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var code = codigoDe(cart);
        if (code) irAlCheckout(code);
        else {
          /* Sin gel de oferta (compra única, solo geles, accesorios): a esta
             cesta no le toca NINGÚN cupón de oferta. Cookie fuera Y
             ?discount= vacío, que es lo único que desactiva un código
             amarrado a la sesión (cazado en el live con la compra única). */
          try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
          irAlCheckout('');
        }
      })
      .catch(seguir);
  }

  function boot() {
    if (bound) return;
    document.addEventListener('click', onClickCapture, true);
    bound = true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
